/**
 * @generated SignedSource<<c06a595d30a83891fcced5f125ec317e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type rows_jiraProject$data = {
  readonly " $fragmentSpreads": FragmentRefs<"row_nativeIssueTable_project">;
  readonly " $fragmentType": "rows_jiraProject";
};
export type rows_jiraProject$key = {
  readonly " $data"?: rows_jiraProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"rows_jiraProject">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "rows_jiraProject",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "row_nativeIssueTable_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "191ecc0805ec45cf34336a9298bd8638";

export default node;
